import { ReactComponent as SiteLogo } from "../../../assets/images/logo.svg";
import { Link } from "react-router-dom";
import { HOME_ROUTE, LOGIN_ROUTE } from "../../../routes";
// import Avatar from "../avatar/avatar";

import {ReactComponent as Avatar} from "../../../assets/icons/avatar.svg" ;

import "./navbar.scss";
import { useEffect, useState } from "react";

const Navbar = ({
    navLinks = [],
    sidebarLinks = [],
    navButtons = [],
    sidebarButtons = [],
    navHeight = "5rem",
}) => {
    const [screenWidth, setScreenWidth] = useState(1400);

    const setWidth = () => {
        setScreenWidth(window.innerWidth);
    };

    useEffect(() => {
        setScreenWidth(window.innerWidth);
        window.addEventListener("resize", setWidth);
        return () => window.removeEventListener("resize", setWidth);
    }, []);

    return (
        <>
            <nav
                className="navbar navbar-light bg-light navbar-expand fixed-top shadow w-100"
                style={{ height: navHeight, top: 0, left: 0 }}
            >
                <div className={(screenWidth >= 1220 && screenWidth < 1400) ? "container-xxl" : "container"}>
                    <div
                        className="d-block d-sm-block d-md-block d-lg-block d-xl-none"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasExample"
                    >
                        <span className="btn fs-2 material-icons">menu</span>
                    </div>
                    <div>
                        <Link className="navbar-brand" to={HOME_ROUTE}>
                            <SiteLogo className="site-logo" onClick={()=>{
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth"
                                });
                            }} />
                        </Link>
                    </div>
                    <div className="d-none d-sm-none d-md-none d-lg-none d-xl-flex flex-fill">
                        <div className="collapse navbar-collapse flex-fill">
                            <div className="navbar-nav">{navLinks}</div>
                        </div>
                        <div className="d-flex">
                            {navButtons.map((btn, i) => (
                                <div className="mx-2 d-flex align-items-center" key={i}>
                                    {btn}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="avatar-container ms-2">
                        <Link to={LOGIN_ROUTE}>
                            <Avatar height="42" />
                        </Link>
                    </div>
                </div>
            </nav>

            <div
                className="offcanvas offcanvas-start"
                tabIndex="-1"
                id="offcanvasExample"
                aria-labelledby="offcanvasExampleLabel"
            >
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvasExampleLabel">
                        <SiteLogo height="3rem" />
                    </h5>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    ></button>
                </div>
                <div className="offcanvas-body h-100">
                    <div className="navbar-nav">{sidebarLinks}</div>
                    <div className="mt-auto">
                        {sidebarButtons.map((btn, i) => (
                            <div
                                data-bs-dismiss="offcanvas"
                                className="row my-2 px-2"
                                key={i}
                            >
                                {btn}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Navbar;
